// The order of a folder's (non-album) listing. Drive lists by name (`orderBy=name`), so ascending is the
// listing's own order and descending is the same reversed.

export type SortDirection = 'asc' | 'desc';

/** Yearly drive roots start newest first (event folders are named by date); other folders A to Z. */
export function defaultSortDirection(isDriveRoot: boolean): SortDirection {
    return isDriveRoot ? 'desc' : 'asc';
}

export function toggleSortDirection(direction: SortDirection): SortDirection {
    return direction === 'asc' ? 'desc' : 'asc';
}

/** A name-ordered listing in the given direction. */
export function inSortDirection<T>(entries: readonly T[], direction: SortDirection): T[] {
    return direction === 'asc' ? [...entries] : [...entries].reverse();
}
